import { FC } from 'react';

import { ic_logout } from '.';

const LogoutIcon: FC<{ width?: number }> = ({ width = 24 }) => {
  return <img src={ic_logout} width={width} alt="" />;
};

export default LogoutIcon;
